import React from 'react'
import { useToast } from '@ztechapps/common.hook'
import { getWindow } from '@ztechapps/common.utils'
import { BusyButton } from '@ztechapps/webui.button'
import { buildBlogPreviewUrl } from '@ztechapps/blog.common'

export type OpenPreviewButtonProps = {
  blogId: string
  slug: string
  disabled?: boolean
}

/**
 * Opens the standalone preview for a blog post in a new tab.
 */
export const OpenPreviewButton = ({ blogId, slug, disabled = false }: OpenPreviewButtonProps) => {
  const { showSuccess } = useToast()

  const onOpen = () => {
    // New-tab shape follows the rank-1 open-in-new-tab precedent
    // (`apps/panelpunches/admin/src/view/productions/item/consumption/RowAction.tsx:107-114`),
    // routed through `getWindow()` per the WebUI guide's no-bare-window rule.
    getWindow().open(buildBlogPreviewUrl(getWindow().location.origin, slug), '_blank', 'noopener,noreferrer')
    showSuccess({ message: 'Preview opened in a new tab.' })
  }

  return (
    <BusyButton text="Open preview" icon="arrow-up-right-from-square" disabled={disabled || !blogId} onClick={onOpen} />
  )
}
